// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i6zz","left":"styles_left__2eepL"};